import { supabase } from '@/integrations/supabase/client';
import { ApiResult, ok, err, ApiError } from '../errors';

// ============ Types ============

export interface AnalyticsEventInput {
  event_type: 'page_view' | 'button_click' | 'feature_usage' | 'video_engagement' | 'article_engagement' | 'audio_engagement' | 'user_journey';
  event_name: string;
  event_data?: Record<string, any>;
  page_path?: string;
  product_id?: string; // Product identifier: 'mindcotine', 'mindco-relief', or 'admin'
}

// ============ Mutations ============

export async function trackAnalyticsEvent(
  userId: string | null,
  sessionId: string,
  input: AnalyticsEventInput & {
    referrer?: string;
    user_agent?: string;
    device_type?: string;
  }
): Promise<ApiResult<null>> {
  const eventData = {
    user_id: userId,
    session_id: sessionId,
    event_type: input.event_type,
    event_name: input.event_name,
    event_data: input.event_data ? JSON.stringify(input.event_data) : null,
    page_path: input.page_path,
    referrer: input.referrer,
    user_agent: input.user_agent,
    device_type: input.device_type,
    product_id: input.product_id || null, // Track which product the event belongs to
    created_at: new Date().toISOString(),
  };

  const { error } = await supabase.from('analytics_events').insert([eventData]);

  if (error) {
    return err(ApiError.fromSupabaseError(error));
  }

  return ok(null);
}
